import React from 'react';
import './Contact.css';
import emailjs from "emailjs-com"
import contactImg from "./img/mahmuddeveloper.png"
function Contact() {
    const sendEmail=e=>{
        e.preventDefault();

        emailjs.sendForm('gmail', 'template_26s4ohf', e.target, 'user_vkcrjViWxKHe6mdvGn6DK')
          .then((result) => {
              console.log(result.text);
          }, (error) => {
              console.log(error.text);
          });
          e.target.reset();
    }
    return (
        <div className="contact  component__space" id="contract">
            <div className="row container">
                <div className="col__2">
                    <div className="contact__box">
                        <div className="contact__meta">
                            <h1 className="hire__text">Hire Me.</h1>
                            <p className="hire__text white">I am available for freelance work. Connect with me via phone:</p>
                           <p className="hire__text white"><strong>+8801773289420</strong> or email <strong>abu.hasan.mahamud@gmail.com</strong></p>
                        </div>
                        <div className="input__box">
                         <form  onSubmit={sendEmail}>
                            <input type="text" className="contact name" placeholder="Your name *"   name="name"/>
                            <input type="text" className="contact email" placeholder="Your Email *"  name="email" />
                            
                            <textarea name="message" id="message" placeholder="Write Your message"  name="message"></textarea>
                            <button className="btn contact pointer" type="submit">Submit</button>
                         </form>
                        </div>
                    </div>
                </div>
                <div className="col__2">
                    <img src={contactImg} alt="" className="contact__img" />
                </div>
            </div>
        </div>
    )
}

export default Contact
